import { useEffect } from 'react'

type WindowWithDyLoader = Window & { __dkLoadDY?: () => void }

export function useLoadDynamicYieldAfterHydration() {
  useEffect(() => {
    ;(window as WindowWithDyLoader).__dkLoadDY?.()
  }, [])
}
